import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrFormikField, {
  SR_FIELD_THEME_CHECKBOX_BLUE,
} from 'client/components/SrFormikField';
import SrText from 'client/components/SrText';
import SrCollapsibleRow from 'client/components/SrCollapsibleRow';

export const partnerEditPropertyDetailsFormFields = [
  {
    id: 'hasRefrigerator',
    title: 'Refrigerator',
    type: 'checkbox',
  },
  {
    id: 'hasWasher',
    title: 'Washer In-Unit',
    type: 'checkbox',
  },
  {
    id: 'hasDryer',
    title: 'Dryer In-Unit',
    type: 'checkbox',
  },
  {
    id: 'hasWasherDryerConnections',
    title: 'Washer/Dryer Connections',
    type: 'checkbox',
  },
  {
    id: 'hasMicrowave',
    title: 'Microwave',
    type: 'checkbox',
  },
  {
    id: 'hasGasStove',
    title: 'Gas Stove',
    type: 'checkbox',
  },
  {
    id: 'hasElectricStove',
    title: 'Electric Stove',
    type: 'checkbox',
  },
  {
    id: 'hasDishWasher',
    title: 'Dishwasher',
    type: 'checkbox',
  },
];

class SrPartnerMarketListingEditPropertyDetailsModal extends Component {
  static propTypes = {
    initialValues: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }

  static defaultProps = {
    initialValues: {},
  }

  render() {
    const {
      initialValues,
      onClose,
      onSubmit,
    } = this.props;

    return (
      <SrDarkModal className='SrPartnerMarketListingEditPropertyDetailsModal'>
        <SrModalContent onCloseIconClick={onClose}>
          <Formik
            validate={createFormValidationFn(partnerEditPropertyDetailsFormFields)}
            initialValues={createInitialValues({
              formFields: partnerEditPropertyDetailsFormFields,
              defaultValues: initialValues,
            })}
            onSubmit={onSubmit}
            render={(formikBag) => {
              return (
                <Form className='form'>
                  <div className='header'>
                    <div className='title'>Property Details</div>
                    <div className='subtitle'>Edit & save info for marketing this property</div>
                  </div>
                  <div className='content'>
                    <SrCollapsibleRow title='appliances'>
                      {partnerEditPropertyDetailsFormFields.map((formField) => (
                        <SrFormikField
                          key={formField.id}
                          formField={formField}
                          formikBag={formikBag}
                          className={SR_FIELD_THEME_CHECKBOX_BLUE}
                        />
                      ))}
                    </SrCollapsibleRow>
                  </div>
                  <div className='footer'>
                    <SrText
                      className='cancelButton'
                      weight='medium'
                      size='large'
                      cursor='pointer'
                      onClick={onClose}
                    >
                      Cancel
                    </SrText>
                    <ButtonDeprecated className='submitButton' type='submit'>
                      Save
                    </ButtonDeprecated>
                  </div>
                </Form>
              );
            }}
          />
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrPartnerMarketListingEditPropertyDetailsModal.displayName = 'SrPartnerMarketListingEditPropertyDetailsModal';

export default SrPartnerMarketListingEditPropertyDetailsModal;
